import Package from "../../components/Package/Package";
import Hero2 from "../../components/hero2/hero2";
export default function PackagePage() {
  return (
    <>
      {/* Placeholder for Header! */}
      <Hero2 />
      <Package />
    </>
  );
}
